export default "/images/garmin_device.webp"